import { render, staticRenderFns } from "./CardStatisticByPlatform.vue?vue&type=template&id=6d6529c6"
import script from "./CardStatisticByPlatform.vue?vue&type=script&lang=js"
export * from "./CardStatisticByPlatform.vue?vue&type=script&lang=js"
import style0 from "./CardStatisticByPlatform.vue?vue&type=style&index=0&id=6d6529c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports